import React, { useState } from 'react';

import PropTypes from 'prop-types';

// Components
import { Mui, PerfectScrollbar, TextField } from 'components';
import { Dialogs } from 'components/common';

const useStyles = Mui.makeStyles(() => ({
  lastBorder: { '& tr:last-child td': { borderBottom: 0 } },
}));

function EarlyPaymentDiscounts({ canEdit = true, formik, formMessages, onRemoveDiscount }) {
  // Hooks
  const classes = useStyles();

  // Constants
  const disabled = formik.isSubmitting || !canEdit;

  // States
  const [remove, setRemove] = useState(null);

  // Actions
  const handleAddDiscount = () => {
    const earlyPaymentDiscounts = structuredClone(formik.values.earlyPaymentDiscounts);
    formik.setFieldValue('earlyPaymentDiscounts', [
      ...earlyPaymentDiscounts,
      { days: 0, fixedAmount: 0, percentageAmount: 0 },
    ]);
  };

  const handleRemoveDiscount = async index => {
    if (onRemoveDiscount && formik.values.earlyPaymentDiscounts[index]?.uid) {
      await onRemoveDiscount(formik.values.earlyPaymentDiscounts[index].uid);
    }
    const earlyPaymentDiscounts = formik.values.earlyPaymentDiscounts?.filter(
      (item, i) => i !== index,
    );
    formik.setFieldValue('earlyPaymentDiscounts', [...earlyPaymentDiscounts]);
    setRemove(null);
  };

  return (
    <>
      <Mui.Card variant="outlined">
        <PerfectScrollbar>
          <Mui.Box minWidth={400}>
            <Mui.Table>
              <Mui.TableHead>
                <Mui.TableRow>
                  <Mui.TableCell>Dias antes do vencimento</Mui.TableCell>
                  <Mui.TableCell>Desconto fixo</Mui.TableCell>
                  <Mui.TableCell>Desconto percentual</Mui.TableCell>
                  {!!canEdit && <Mui.TableCell>Ações</Mui.TableCell>}
                </Mui.TableRow>
              </Mui.TableHead>
              <Mui.TableBody>
                {formik.values.earlyPaymentDiscounts?.length === 0 && (
                  <Mui.TableRow>
                    <Mui.TableCell colSpan={canEdit ? 4 : 3} align="center">
                      Nenhum desconto gerado
                    </Mui.TableCell>
                  </Mui.TableRow>
                )}
                {formik.values.earlyPaymentDiscounts?.map((discount, index) => (
                  <Mui.TableRow key={`discount-${index.toString()}`}>
                    <Mui.TableCell>
                      <TextField
                        required
                        name="days"
                        type="number"
                        size="small"
                        label={formMessages.earlyPaymentDiscounts.days.label}
                        disabled={disabled}
                        value={formik.values.earlyPaymentDiscounts[index]?.days}
                        margin="none"
                        onChange={event => {
                          formik.setFieldTouched(`earlyPaymentDiscounts[${index}].days`, true);
                          formik.setFieldValue(
                            `earlyPaymentDiscounts[${index}].days`,
                            event.target.value,
                            true,
                          );
                        }}
                      />
                    </Mui.TableCell>
                    <Mui.TableCell>
                      <TextField
                        name="fixedAmount"
                        envelope="currency"
                        size="small"
                        label={formMessages.earlyPaymentDiscounts.fixedAmount.label}
                        disabled={disabled}
                        value={formik.values.earlyPaymentDiscounts[index]?.fixedAmount}
                        margin="none"
                        onChange={event => {
                          const { value } = event.target;
                          formik.setFieldTouched(
                            `earlyPaymentDiscounts[${index}].fixedAmount`,
                            true,
                          );
                          formik.setFieldValue(
                            `earlyPaymentDiscounts[${index}].fixedAmount`,
                            value || 0,
                            true,
                          );
                        }}
                      />
                    </Mui.TableCell>
                    <Mui.TableCell>
                      <TextField
                        name="percentageAmount"
                        envelope="percentage"
                        size="small"
                        label={formMessages.earlyPaymentDiscounts.percentageAmount.label}
                        disabled={disabled}
                        value={formik.values.earlyPaymentDiscounts[index]?.percentageAmount}
                        margin="none"
                        onChange={event => {
                          const { value } = event.target;
                          formik.setFieldTouched(
                            `earlyPaymentDiscounts[${index}].percentageAmount`,
                            true,
                          );
                          formik.setFieldValue(
                            `earlyPaymentDiscounts[${index}].percentageAmount`,
                            value || 0,
                            true,
                          );
                        }}
                      />
                    </Mui.TableCell>
                    {!!canEdit && (
                      <Mui.TableCell>
                        <Mui.Tooltip title="Remover">
                          <Mui.IconButton onClick={() => setRemove(index)}>
                            <Mui.Icon>delete</Mui.Icon>
                          </Mui.IconButton>
                        </Mui.Tooltip>
                      </Mui.TableCell>
                    )}
                  </Mui.TableRow>
                ))}
              </Mui.TableBody>
              {!!canEdit && (
                <Mui.TableFooter className={classes.lastBorder}>
                  <Mui.TableRow>
                    <Mui.TableCell colSpan={4}>
                      <Mui.Box display="flex" justifyContent="flex-end">
                        <Mui.Button color="secondary" size="large" onClick={handleAddDiscount}>
                          Adicionar desconto
                        </Mui.Button>
                      </Mui.Box>
                    </Mui.TableCell>
                  </Mui.TableRow>
                </Mui.TableFooter>
              )}
            </Mui.Table>
          </Mui.Box>
        </PerfectScrollbar>
      </Mui.Card>
      <Dialogs.Confirmation
        open={remove !== null}
        onClose={() => setRemove(null)}
        onConfirm={() => handleRemoveDiscount(remove)}>
        Deseja excluir o desconto de pontualidade?
      </Dialogs.Confirmation>
    </>
  );
}

EarlyPaymentDiscounts.propTypes = {
  canEdit: PropTypes.bool,
  formik: PropTypes.object,
  formMessages: PropTypes.object,
  onRemoveDiscount: PropTypes.func,
};

export default EarlyPaymentDiscounts;
